import type { EventData } from "../../api/client";

export const LOCAL_ID = "local";
const KEY = "secoursnav.localEvent";

/** Event file opened in the browser: kept for the tab session only, never sent for storage. */
export function saveLocalEvent(e: EventData) {
  sessionStorage.setItem(KEY, JSON.stringify(e));
}

export function loadLocalEvent(): EventData | null {
  const t = sessionStorage.getItem(KEY);
  return t ? (JSON.parse(t) as EventData) : null;
}
